import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { authInterceptor } from '../auth/auth.interceptor';
import { projectNotFoundInterceptor } from '../projects/missing-projects';
import { apiUrlInterceptor } from './api-url.interceptor';
import { errorInterceptor } from './error.interceptor';

export function provideHttp(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(
      withInterceptors([
        apiUrlInterceptor,
        projectNotFoundInterceptor,
        errorInterceptor,
        authInterceptor,
      ]),
    ),
  ]);
}
